import React from 'react'

import Heading from '~/app/components/atoms/Heading'
import Button from '~/app/components/atoms/Button'
import Paragraph from '~/app/components/atoms/Paragraph'
import Accordion from '~/app/components/molecules/Accordion'
import { resolveHref } from '~/app/lib/sanity.links'

const InnerBlocks = ({ blocks }) => {
  return (
    <>
      {blocks?.map((block, index) => {
        const key = block?._key || index
        switch (block._type) {
          case 'heading':
            return <InnerBlocks.Title key={key} data={block} />
          case 'textBlock':
            return <InnerBlocks.Paragraphs key={key} data={block} />
          case 'button':
            return (
              <div key={key} className="pt-8 font-sans">
                <Button style={block.style} link={block.link}>
                  {block?.link?.label}
                </Button>
              </div>
            )
          default:
            return null
        }
      })}
    </>
  )
}

export default InnerBlocks

InnerBlocks.Title = Title
InnerBlocks.Paragraphs = Paragraphs

/* compound components */
function Title({ data }) {
  return (
    <>
      <Heading
        size={data.heading.tag}
        type={data.heading.tag}
      >
        {data.heading.heading}
      </Heading>
    </>
  )
}

function Paragraphs({ data }) {
  return (
    <>
      <Paragraph portableText>{data.body}</Paragraph>
    </>
  )
}
